var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTw = function SvgIconTw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 12V0C5.373 0 0 5.373 0 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m10.435 7.023-1.466.69.78 1.419-1.59-.305-.202 1.608-1.109-1.183-1.108 1.183-.202-1.608-1.591.305.78-1.42-1.465-.69 1.465-.688-.78-1.42 1.591.305.202-1.608 1.108 1.182 1.109-1.182.201 1.608 1.592-.305-.78 1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M6.849 9.257a2.234 2.234 0 1 0 0-4.468 2.234 2.234 0 0 0 0 4.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M6.848 8.214c-.656 0-1.19-.534-1.19-1.19 0-.657.534-1.19 1.19-1.19.657 0 1.19.533 1.19 1.19s-.533 1.19-1.19 1.19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTw;